export default __webpack_public_path__ + "static/media/7517d0e90baddb22.3a63c2d1d1a348864586b31dc6e8b59a.svg";